import { WalletType } from '~/shared';
import { createSlice } from '../wrappers';

const initialState = {
	name: null as string | null,
	paymentWallet: WalletType.Cash,
	parkingSlotsErrorVisible: false,
};

const playerSlice = createSlice({
	name: 'player',
	initialState,
	reducers: {
		setPaymentCurrency: (state, action) => {
			state.paymentWallet = action.payload;
		},
		setName: (state, action) => {
			state.name = action.payload;
		},
		setParkingSlotsErrorVisible: (state, action) => {
			state.parkingSlotsErrorVisible = action.payload;
		},
	},
});

export const { setPaymentCurrency, setName, setParkingSlotsErrorVisible } =
	playerSlice.actions;

export default playerSlice.reducer;
